export const state = {
  token: null,
  roles: {},
  isGuest: false,
  name: '',
  profileData: null,
  isStaff: false,
};
